import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms'; 
import { CommonModule } from '@angular/common';

import { Unidades } from '../../Unidades/models/unidades'; 
import { UnidadesService } from '../../Service/unidades-service';
import { UdcsService } from '../../Service/udcs-service';
import { UppercaseDirective } from '../../util/uppercase'; 
import { ToastService } from '../../Service/toast-service'; 
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-unidad-add',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, UppercaseDirective, RouterLink],
  templateUrl: './unidad-add.html',
  styleUrl: './unidad-add.css',
})
export class UnidadAdd implements OnInit {
  unidadForm!: FormGroup;

  // Catálogo dinámico para asociar al dueño del vehículo ({ an8: number, name: string })
  clientes: any[] = [];
  marcas: any[] = [];     
  submarcas: any[] = [];  
  listaAnios: number[] = [];

  // Catálogos estáticos de control
  tiposCombustible: string[] = ['GASOLINA', 'DIÉSEL', 'HÍBRIDO', 'ELÉCTRICO', 'GAS LP'];
  tiposServicio: string[] = ['PARTICULAR', 'PÚBLICO', 'CARGA', 'PLATAFORMA/APP'];
  estatusUnidad: string[] = ['ACTIVO', 'INACTIVO', 'EN TALLER', 'BAJA'];
  coloresUnidad: string[] = [
    'BLANCO', 'NEGRO', 'GRIS', 'PLATA', 'ROJO', 'AZUL', 
    'VERDE', 'AMARILLO', 'CAFÉ', 'NARANJA', 'MORADO', 'BEIGE', 'MULTICOLOR'
  ];

  constructor(
      private unidadesService: UnidadesService,
      private udcsService: UdcsService,
      private fb: FormBuilder,
      private cdr: ChangeDetectorRef,
      public toastService: ToastService,
      private router: Router // 🚀 INYECTADO: Motor nativo de redirección de rutas
  ){}

  ngOnInit(): void {
    this.initForm();
    //this.escucharCambioPropietario(); // 🌟 Inyectamos el rastreador aquí
    this.cargarCatatogoClientes();         
    this.cargarMarcasUDC(); 
    this.cargarAniosDinamicos(); 
  }

  private initForm(): void {
    this.unidadForm = this.fb.group({
      id: [0], 

      // =========================================================================
      // 💡 CORREGIDO: Mapeo homólogo 'propietario' en lugar de 'customer'
      // =========================================================================
      propietario: this.fb.group({
        an8: [null, [Validators.required]] // Recibe el número de 8 dígitos
      }),

      marca: ['', [Validators.required]], 
      submarca: [{ value: '', disabled: true }, [Validators.required]], 
      placas: ['', [Validators.required]],
      modelo: ['', [Validators.required]],
      aniofabricacion: ['', [Validators.required, Validators.min(1900)]],
      tipocombustible: ['', [Validators.required]],
      tiposervicio: ['', [Validators.required]],
      numerovin: ['', [Validators.required]],
      numeromotor: ['', [Validators.required]],
      fechaalta: [this.getFechaActual(), [Validators.required]], 
      fechabaja: [null], 
      status: ['ACTIVO', [Validators.required]], 
      color: ['', [Validators.required]],
      tcirculacion: ['', [Validators.required]]
    });
  }

  cargarCatatogoClientes(): void {
    this.unidadesService.getClientesActivos().subscribe({
      next: (data) => {
        // 🌟 SOLUCIÓN: Forzamos una nueva referencia en memoria para que *ngFor reaccione
        this.clientes = [...data]; 
        
        console.log('Clientes cargados con éxito en el componente:', this.clientes);
        
        // Aseguramos el redibujado inmediato de la UI
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      },
      error: (err) => console.error('Error al cargar clientes en unidades', err)
    });
  }

  // 🌟 MÉTODO DE DIAGNÓSTICO CORREGIDO PARA TYPESCRIPT
/*   private escucharCambioPropietario(): void {
    const an8Control = this.unidadForm.get('propietario.an8');
    
    if (an8Control) {
      an8Control.valueChanges.subscribe({
        next: (valor) => {
          console.log('--- DETECTOR REACTIVO ---');
          console.log(`El control 'propietario.an8' cambió internamente a: ${valor} (Tipo: ${typeof valor})`);
          console.log('Estado actual del formulario global:', this.unidadForm.value);
        },
        error: (err) => console.error('Error en el pipeline del formulario:', err)
      });
    } else {
      console.error('❌ CRÍTICO: No se pudo localizar la ruta reactiva "propietario.an8" en initForm()');
    }
  } */

  cargarMarcasUDC(): void {
    this.udcsService.getMarcasAutos().subscribe({
      next: (data) => {
        this.marcas = data; 
        this.cdr.detectChanges();
      },
      error: (err) => console.error('Error al obtener marcas UDC', err)
    });
  }

  onMarcaSeleccionada(event: any): void {
    const codigoMarca = event.target.value;
    const submarcaControl = this.unidadForm.get('submarca');

    this.submarcas = [];
    submarcaControl?.setValue('');
    submarcaControl?.disable();

    if (codigoMarca) {
      this.udcsService.getSubmarcasPorMarca(codigoMarca).subscribe({
        next: (data) => {
          this.submarcas = data; 
          if (this.submarcas.length > 0) {
            submarcaControl?.enable(); 
          }
          this.cdr.detectChanges();
        },
        error: (err) => console.error('Error al cargar submarcas para: ' + codigoMarca, err)
      });
    }
  }

  // =========================================================================
  // ESCUCHADOR CORE REFACTORIZADO AL MODELO NUMÉRICO DEL ADRESS BOOK
  // =========================================================================
/*   onClienteSeleccionado(event: any): void {
    const an8ValueRaw = event.target.value;
    const an8Control = this.unidadForm.get('propietario.an8'); 

    if (an8ValueRaw) {
      // Convertimos el valor string del HTML en un entero nativo puro de JDE
      const an8Entero = parseInt(an8ValueRaw, 10);
      an8Control?.setValue(an8Entero);
      console.log('Vínculo de propiedad establecido para el AN8:', an8Entero);
    } else {
      an8Control?.setValue(null);
    }
  } */

  getFechaActual(): string {
    const hoy = new Date();
    const anio = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, '0');
    const dia = String(hoy.getDate()).padStart(2, '0');
    const horas = String(hoy.getHours()).padStart(2, '0');
    const minutos = String(hoy.getMinutes()).padStart(2, '0');
    
    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  }

  addUnidad(): void {
    if (this.unidadForm.invalid) {
      // 1. Ilumina instantáneamente en rojo TODOS los campos inválidos vacíos de la pantalla
      this.unidadForm.markAllAsTouched(); 
      
      // 2. Buscamos el primer campo que falló en el HTML (.is-invalid)
      const primerError = document.querySelector('.is-invalid');
      if (primerError) {
        // Hace un scroll automático y suave enfocando la pantalla en el error
        primerError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      console.warn('El formulario de unidades contiene errores de validación. Campos iluminados.');
      return;
    }

    // Usamos getRawValue() para forzar a Angular a empaquetar campos deshabilitados (como la submarca)
    const unidad: Unidades = this.unidadForm.getRawValue();

    console.log('Despachando Unidad Reactiva corporativa (AN8):', unidad);
    
    this.unidadesService.createUnidad(unidad).subscribe({
      next: (res) => {
        console.log('Unidad guardada con éxito en el ecosistema', res);
        
/*         this.toastService.showSuccess(
          'Unidad Registrada', 
          `El vehículo con placas [${unidad.placas.toUpperCase()}] ha sido vinculado con éxito al cliente.`
        );

        this.unidadForm.reset({ 
          id: 0, 
          status: 'ACTIVO', 
          fechaalta: this.getFechaActual() 
        });

        this.unidadForm.get('propietario.an8')?.setValue(null);
        this.unidadForm.get('submarca')?.setValue('');
        this.unidadForm.get('submarca')?.disable();
        
        this.submarcas = [];
        this.cdr.detectChanges(); */

        this.router.navigate(['/unidad'], {
          state: {
            mostrarAlertaExito: true,
            mensajeToast: `El vehículo con placas [${unidad.placas}] ha sido registrado con éxito en el sistema.`
          }
        });

      },
      error: (err) => {
        console.error('Error fatal al persistir la unidad en el servidor', err);
        // Toast flotante de error por si el servidor falla o hay placas duplicadas
        this.toastService.showDanger('Error de Servidor', err.error || 'No se pudo guardar el vehículo.');
      }
    });
  }  

  cargarAniosDinamicos(): void {
    this.udcsService.getRangoAnios().subscribe({
      next: (data) => {
        this.listaAnios = data; 
        this.cdr.detectChanges();
      },
      error: (err) => console.error('Error al cargar rango de años', err)
    });
  }
  
}